import React, { useState, useCallback, useRef } from 'react';
import Map from './Map';
import FavoritesPanel from './FavoritesPanel';
import ResortDetail from './ResortDetail';
import './RankingMap.css';

const FavoritesMap = () => {
  const [selectedResort, setSelectedResort] = useState(null);
  const [markers, setMarkers] = useState([]);
  const mapRef = useRef(null);

  // 处理标记更新
  const handleMarkersUpdate = useCallback((newMarkers) => {
    setMarkers(newMarkers);
  }, []);

  // 处理关闭详情页
  const handleCloseDetail = useCallback(() => {
    setSelectedResort(null);
  }, []);

  return (
    <div className="ranking-map-container">
      <div className="map-container">
        <Map
          ref={mapRef}
          markers={markers}
          selectedResort={selectedResort}
          onResortSelect={setSelectedResort}
          type="favorites"
        />
      </div>
      <div className="ranking-panel">
        <FavoritesPanel
          onMarkersUpdate={handleMarkersUpdate}
          selectedResort={selectedResort}
          onResortSelect={setSelectedResort}
        />
      </div>
      {selectedResort && (
        <div className="resort-detail-overlay">
          <ResortDetail 
            resort={selectedResort} 
            onClose={handleCloseDetail}
          />
        </div>
      )}
    </div>
  );
};

export default FavoritesMap; 